export const CourseStatusConstants = {
    STATUS_APPROVED: '136cc269-8d33-4c10-8fff-11c295d74b1b',
    STATUS_PENDING: '30a78223-b188-4153-a3d3-22a3e39db4e9',
    SELF_COLLECT: '7bcaf90c-10cb-4beb-b45f-2f846784000d',
    SHIPPED: '2e37f53c-146c-435b-9494-5efd5d921af7',
    FEEDBACK_PROVIDED: 'f5b6d264-1da6-4903-ad10-609756141b97',
    SCORES_APPROVED: '504cff9e-e1c0-4f33-9bfa-87deb13c7866',
    THREE_D_REDIRECT: '9277d545-0388-44eb-afa1-8bb063cf85a1',
    APPROVED: '72bb7ffc-112b-4ab6-a739-a6567feb031d',
    EVALUATION_FAILED: '2ca84af0-0082-49fd-9af3-b2fc2bc56dce',
    SCORES_DECLINED: '84945771-de9f-4e20-b2b2-cff02dede5e9',
    PAYMENT_RECEIVED: '7c57d428-726c-4243-89bc-df93dc560dda',
    SCORES_SUBMITTED: 'de6a2513-81eb-465a-be73-e0d2277cb2e3',
    EVALUATION_PASSED: '1deb69e2-3e7b-48e2-9126-ec6003e6528e',
    PENDING: '1a96124d-d5bb-4448-be40-f2753f285106',
    DECLINED: '20123cc8-a9b9-4351-a851-fba219c54c65',
    FORFEITED: '1a92b7a2-30c8-43be-3c19-08deba6344f2'
}